import { AccountGroupOutlineIcon } from './AccountGroupOutlineIcon';

/**
 * author: GreenTurtwig
 * id 7DFB1292-669B-4769-A107-FA3359281270
 * name account-group-outline
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-group-outline.svg
 * tags
 * - Account / User 
 */
export const UsersGroupOutlineIcon = AccountGroupOutlineIcon;
export default UsersGroupOutlineIcon